import axios from "axios";
import Vue from "vue";
import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

let quickSearchSuggestionsCancelSource = null;
let quickSearchContactSuggestionsCancelSource = null;
let quickSearchContactCountCancelSource = null;
let quickSearchContactDetailsCancelSource = null;
const quickSearchCancelSources = {};

export function cancelQuickSearchContactDetails() {
    if (quickSearchContactDetailsCancelSource) {
        quickSearchContactDetailsCancelSource.cancel("cleared");
        quickSearchContactDetailsCancelSource = null;
    }
}

export function cancelQuickSearchContactSuggestions() {
    if (quickSearchContactSuggestionsCancelSource) {
        quickSearchContactSuggestionsCancelSource.cancel("cleared");
        quickSearchContactSuggestionsCancelSource = null;
    }
}

export function cancelQuickSearchContactCount() {
    if (quickSearchContactCountCancelSource) {
        quickSearchContactCountCancelSource.cancel("cleared");
        quickSearchContactCountCancelSource = null;
    }
}

export function cancelQuickSearchSuggestions() {
    if (quickSearchSuggestionsCancelSource) {
        quickSearchSuggestionsCancelSource.cancel("cleared");
        quickSearchSuggestionsCancelSource = null;
    }
    cancelQuickSearchContactSuggestions();
    cancelQuickSearchContactCount();
    cancelQuickSearchContactDetails();
}

export function cancelQuickSearch(type = null) {
    if (type) {
        if (quickSearchCancelSources[type]) {
            quickSearchCancelSources[type].cancel("cleared");
            quickSearchCancelSources[type] = null;
        }
        return;
    }
    Object.keys(quickSearchCancelSources).forEach((key) => {
        if (quickSearchCancelSources[key]) {
            quickSearchCancelSources[key].cancel("cleared");
            quickSearchCancelSources[key] = null;
        }
    });
}

// action types
export const USERS_LIST = "users_list";
export const NOCES_LIST = "NOCES_LIST";
export const QUICK_SEARCH = "QUICK_SEARCH";
export const QUICK_SEARCH_SUGGESTIONS = "QUICK_SEARCH_SUGGESTIONS";
export const QUICK_SEARCH_CONTACT_SUGGESTIONS = "QUICK_SEARCH_CONTACT_SUGGESTIONS";
export const QUICK_SEARCH_CONTACT_COUNT = "QUICK_SEARCH_CONTACT_COUNT";
export const QUICK_SEARCH_CONTACT_DETAILS = "QUICK_SEARCH_CONTACT_DETAILS";
export const QUICK_SEARCH_SPELL_DICTIONARY = "QUICK_SEARCH_SPELL_DICTIONARY";
export const STAFF_LIST = "staff_list";
export const USER_AGENCIES_LIST = "USER_AGENCIES_LIST";
export const STAFF_LIST_ALL = "STAFF_LIST_ALL";
export const CREATE_USER = "create_user";
export const UPDATE_USER = "update_user";
export const CREATE_DEVELOPER = "CREATE_DEVELOPER";
export const UPDATE_DEVELOPER = "UPDATE_DEVELOPER";
export const CREATE_NOC = "CREATE_NOC";
export const GET_DEVELOPER_DETAILS = "GET_DEVELOPER_DETAILS";
export const CREATE_DEVELOPER_USER = "CREATE_DEVELOPER_USER";
export const UPDATE_DEVELOPER_USER = "UPDATE_DEVELOPER_USER";
export const GET_DEVELOPER_USER_DETAILS = "GET_DEVELOPER_USER_DETAILS";
export const UPDATE_DEVELOPER_USER_STATUS = "UPDATE_DEVELOPER_USER_STATUS";
export const CREATE_AGENCY_USER = "CREATE_AGENCY_USER";
export const UPDATE_AGENCY_USER = "UPDATE_AGENCY_USER";
export const GET_AGENCY_USER_DETAILS = "GET_AGENCY_USER_DETAILS";
export const UPDATE_AGENCY_USER_STATUS = "UPDATE_AGENCY_USER_STATUS";
export const GET_BROKER_DETAILS = "GET_BROKER_DETAILS";
export const APPROVE_BROKER_DOCUMENTS = "APPROVE_BROKER_DOCUMENTS";
export const REJECT_BROKER_DOCUMENTS = "REJECT_BROKER_DOCUMENTS";
export const APPROVE_BROKER_DOCUMENT = "APPROVE_BROKER_DOCUMENT";
export const REJECT_BROKER_DOCUMENT = "REJECT_BROKER_DOCUMENT";
export const APPROVE_BROKER_IMAGE = "APPROVE_BROKER_IMAGE";
export const REJECT_BROKER_IMAGE = "REJECT_BROKER_IMAGE";
export const APPROVE_BROKER_WEBSITE = "APPROVE_BROKER_WEBSITE";
export const REJECT_BROKER_WEBSITE = "REJECT_BROKER_WEBSITE";
export const UPDATE_BROKER_STATUS = "UPDATE_BROKER_STATUS";
export const VERIFY_BROKER_EMAIL = "VERIFY_BROKER_EMAIL";
export const UPDATE_USER_STATUS = "update_user_status";
export const UPDATE_NOC_STATUS = "UPDATE_NOC_STATUS";
export const UPDATE_USER_COUNTRY = "update_user_country";
export const DELETE_USER = "delete_user";
export const DELETE_AGENCY = "delete_agency";
export const DELETE_NOC = "DELETE_NOC";
export const GET_USER_DETAILS = "get_user_details";
export const GET_USER_LOGS = "get_user_logs";
export const GET_ACTIVITY_LOGS = "get_activity_logs";
export const GET_USER_ROLES = "get_user_roles";
export const GET_USER_ROLES_EXCEPT = "get_user_roles_except";
export const ASSIGN_ROLES_TO_USER = "assign_roles_to_user";
export const REMOVE_ROLE_FROM_USER = "remove_role_from_user";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const CLEAR_USER_ERRORS = "clearUserErrors";

// mutation types
export const SET_USER_ERROR = "setUserError";
export const REMOVE_USER_ERRORS = "removeUserErrors";

const state = {
    errors: null,
    uploadedUserDetails: {},
    uploadedUserBankDetails: [],
    uploadedUserCardDetails: [],
    uploadedUserComments: []
};


const actions = {
    [USERS_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/users?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [NOCES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/noces?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [QUICK_SEARCH](context, payload) {
        const searchType = payload.type;
        if (quickSearchCancelSources[searchType]) {
            quickSearchCancelSources[searchType].cancel("superseded");
        }
        quickSearchCancelSources[searchType] = axios.CancelToken.source();
        ApiService.setHeader();
        let url = "api/quicksearch?q=" + encodeURIComponent(payload.q)
            + "&page=" + encodeURIComponent(payload.page)
            + "&type=" + encodeURIComponent(searchType);
        if (payload.activityLog) {
            url += "&quick_search_activity_log=1";
        }
        return Vue.axios.get(url, {cancelToken: quickSearchCancelSources[searchType].token})
            .then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    return data;
                }
                this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                context.commit(SET_USER_ERROR, data.errors);
                return Promise.reject(new Error(data._metadata.message || "Quick search failed"));
            })
            .catch((err) => {
                if (axios.isCancel(err)) {
                    return Promise.reject(err);
                }
                if (err.response && err.response.data && err.response.data.errors) {
                    context.commit(SET_USER_ERROR, err.response.data.errors);
                }
                return Promise.reject(err);
            });
    },
    [QUICK_SEARCH_SPELL_DICTIONARY]() {
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            console.log("[QuickSearch Spell] fetching api/quick-search-spell-dictionary");
            ApiService.simple("api/quick-search-spell-dictionary")
                .then(({data}) => {
                    console.log("[QuickSearch Spell] dictionary response metadata", data._metadata);
                    if (data._metadata.outcomeCode === 0) {
                        const records = data.records || {};
                        console.log("[QuickSearch Spell] dictionary records keys", Object.keys(records));
                        resolve(records);
                    } else {
                        console.warn("[QuickSearch Spell] dictionary bad outcome", data._metadata);
                        reject(new Error(data._metadata.message || "Spell dictionary failed"));
                    }
                })
                .catch((err) => {
                    console.warn("[QuickSearch Spell] dictionary request error", err);
                    reject(err);
                });
        });
    },
    [QUICK_SEARCH_SUGGESTIONS](context, payload) {
        const q = typeof payload === "string" ? payload : (payload && payload.q) || "";
        const activityLog = typeof payload === "object" && payload && payload.activityLog;
        if (quickSearchSuggestionsCancelSource) {
            quickSearchSuggestionsCancelSource.cancel("superseded");
        }
        quickSearchSuggestionsCancelSource = axios.CancelToken.source();
        ApiService.setHeader();
        let url = "api/quick-search-suggestions?q=" + encodeURIComponent(q);
        if (activityLog) {
            url += "&quick_search_activity_log=1";
        }
        return new Promise((resolve, reject) => {
            ApiService.get(
                url,
                "",
                {cancelToken: quickSearchSuggestionsCancelSource.token}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data.records || {});
                    } else {
                        context.commit(SET_USER_ERROR, data.errors);
                        reject(new Error(data._metadata.message || "Quick search suggestions failed"));
                    }
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        reject(err);
                        return;
                    }
                    if (err.response && err.response.data && err.response.data.errors) {
                        context.commit(SET_USER_ERROR, err.response.data.errors);
                    }
                    reject(err);
                });
        });
    },
    [QUICK_SEARCH_CONTACT_SUGGESTIONS](context, q) {
        if (quickSearchContactSuggestionsCancelSource) {
            quickSearchContactSuggestionsCancelSource.cancel("superseded");
        }
        quickSearchContactSuggestionsCancelSource = axios.CancelToken.source();
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.get(
                "api/quick-search-contact-suggestions?q=" + encodeURIComponent(q),
                "",
                {cancelToken: quickSearchContactSuggestionsCancelSource.token}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data.records || {});
                    } else {
                        context.commit(SET_USER_ERROR, data.errors);
                        reject(new Error(data._metadata.message || "Quick search contact suggestions failed"));
                    }
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        reject(err);
                        return;
                    }
                    if (err.response && err.response.data && err.response.data.errors) {
                        context.commit(SET_USER_ERROR, err.response.data.errors);
                    }
                    reject(err);
                });
        });
    },
    [QUICK_SEARCH_CONTACT_COUNT](context, q) {
        if (quickSearchContactCountCancelSource) {
            quickSearchContactCountCancelSource.cancel("superseded");
        }
        quickSearchContactCountCancelSource = axios.CancelToken.source();
        ApiService.setHeader();
        return new Promise((resolve, reject) => {
            ApiService.get(
                "api/quick-search-contact-count?q=" + encodeURIComponent(q),
                "",
                {cancelToken: quickSearchContactCountCancelSource.token}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data.records || {});
                    } else {
                        context.commit(SET_USER_ERROR, data.errors);
                        reject(new Error(data._metadata.message || "Quick search contact count failed"));
                    }
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        reject(err);
                        return;
                    }
                    if (err.response && err.response.data && err.response.data.errors) {
                        context.commit(SET_USER_ERROR, err.response.data.errors);
                    }
                    reject(err);
                });
        });
    },
    [QUICK_SEARCH_CONTACT_DETAILS](context, payload) {
        const ids = Array.isArray(payload) ? payload : (payload && payload.ids) || [];
        const q = Array.isArray(payload) ? "" : (payload && payload.q) || "";
        if (!Array.isArray(ids) || ids.length === 0) {
            return Promise.resolve({contacts: [], contacts_total_count: 0});
        }
        if (quickSearchContactDetailsCancelSource) {
            quickSearchContactDetailsCancelSource.cancel("superseded");
        }
        quickSearchContactDetailsCancelSource = axios.CancelToken.source();
        ApiService.setHeader();
        const query = ids.map((id) => encodeURIComponent(id)).join(",");
        let url = "api/quick-search-contact-details?ids=" + query;
        if (q) {
            url += "&q=" + encodeURIComponent(q);
        }
        return new Promise((resolve, reject) => {
            ApiService.get(
                url,
                "",
                {cancelToken: quickSearchContactDetailsCancelSource.token}
            )
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data.records || {contacts: []});
                    } else {
                        reject(new Error(data._metadata.message || "Quick search contact details failed"));
                    }
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        reject(err);
                        return;
                    }
                    reject(err);
                });
        });
    },
    [STAFF_LIST](context) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getstaff")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [USER_AGENCIES_LIST](context) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getuseragencies")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [STAFF_LIST_ALL](context) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/getstaffall")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_USER_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getuserdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_DEVELOPER_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getdeveloperdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_USER_LOGS](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/getuserlogs/"+payload.userId+"?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_ACTIVITY_LOGS](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/getactivitylogs/"+payload.userId+"?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CREATE_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createuser", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CREATE_NOC](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createnoc", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateuser", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CREATE_DEVELOPER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createdeveloper", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_DEVELOPER](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatedeveloper", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CREATE_DEVELOPER_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createdeveloperuser", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_DEVELOPER_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatedeveloperuser", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_DEVELOPER_USER_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getdeveloperuserdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_DEVELOPER_USER_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatedeveloperuserstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CREATE_AGENCY_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createagencyuser", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_AGENCY_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateagencyuser", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_AGENCY_USER_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getagencyuserdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_AGENCY_USER_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateagencyuserstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_BROKER_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getbrokerdetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_USER_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [APPROVE_BROKER_DOCUMENTS](context, id) {
        return new Promise(resolve => {
            return ApiService.update("api/approvebrokerdocuments", id, {}).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [REJECT_BROKER_DOCUMENTS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/rejectbrokerdocuments", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [APPROVE_BROKER_DOCUMENT](context, payload) {
        return new Promise(resolve => {
            return ApiService.post(`api/approvebrokerdocument/${payload.id}/${payload.field}`, {}).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [REJECT_BROKER_DOCUMENT](context, payload) {
        return new Promise(resolve => {
            return ApiService.post(`api/rejectbrokerdocument/${payload.id}/${payload.field}`, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [APPROVE_BROKER_IMAGE](context, id) {
        return new Promise(resolve => {
            return ApiService.update("api/approvebrokerimage", id, {}).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [REJECT_BROKER_IMAGE](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/rejectbrokerimage", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [APPROVE_BROKER_WEBSITE](context, id) {
        return new Promise(resolve => {
            return ApiService.update("api/approvebrokerwebsite", id, {}).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [REJECT_BROKER_WEBSITE](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/rejectbrokerwebsite", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_BROKER_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatebrokerstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [VERIFY_BROKER_EMAIL](context, id) {
        return new Promise(resolve => {
            return ApiService.post(`api/verifybrokeremail/${id}`, {}).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_USER_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateuserstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_NOC_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatenocstatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_USER_COUNTRY](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/updateusercountry", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [DELETE_AGENCY](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteagency", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [DELETE_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteuser", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [DELETE_NOC](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletenoc", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_USER_ROLES](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/getuserroles/" + payload.slug + "?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [GET_USER_ROLES_EXCEPT](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getuserrolesexcept", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [ASSIGN_ROLES_TO_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/assignrolestouser", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [REMOVE_ROLE_FROM_USER](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/removerolefromuser", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [UPDATE_PROFILE](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/updateprofile", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_USER_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_USER_ERROR, response.errors);
                });
        });
    },
    [CLEAR_USER_ERRORS](context) {
        context.commit(REMOVE_USER_ERRORS);
    },
};

const mutations = {
    [SET_USER_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_USER_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
